export const CautionIcon = ({ className = "w-6 h-6", color = "currentColor" }) => (
<svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#1C2A46" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 16V11.5" stroke="#1C2A46" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 8.01195V8.00195" stroke="#1C2A46" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

);


